import { ChangeDetectionStrategy, Component } from '@angular/core'
import { StaffFacade } from 'libs/gb-dashboard/staff/data-access/src/lib/+state/staff.facade'
import * as StaffActions from 'libs/gb-dashboard/staff/data-access/src/lib/+state/staff.actions'

@Component({
  selector: 'gb-aws-tools',
  templateUrl: './gb-aws-tools.component.html',
  styleUrl: './gb-aws-tools.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbAwsToolsComponent {
  constructor(private staffFacade: StaffFacade) {}

  createInvalidation() {
    this.staffFacade.dispatch(StaffActions.createInvalidation())
  }

  syncKnowledgeSources() {
    this.staffFacade.dispatch(StaffActions.syncKnowledgeSources())
  }
}
